import { Box, Divider, Drawer, FormLabel, Grid, IconButton, TextField, Typography } from "@mui/material";
import { FC } from "react";
import CloseIcon from '@mui/icons-material/Close'
import { useDriverStore } from "../../../hooks/useDriverStore";
import { Formik } from "formik";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { ApiStatus } from "../../../types/api/status";
import { unmaskRUT } from "../../../toolbox/helpers/rut-helper";

interface DriverFormDrawerProps {
    open: boolean
    onClose: () => void
    onList: () => void
}

type ValuesForm = {
    rut: string
    name: string
}

export const DriverFormDrawer: FC<DriverFormDrawerProps> = ({
    open,
    onClose,
    onList
}) => {
    const { status, driverSelected, createDriver, updateDriver } = useDriverStore()

    const isEdit = driverSelected && Object.keys(driverSelected).length > 0
    const data: ValuesForm = {
        rut: driverSelected?.rut || '',
        name: driverSelected?.name || ''
    }

    const validateForm = (values) => {
        let errors: any = {};

        if (!values.rut) errors.rut = "el campo es requerido";
        if (!values.name) errors.name = "el campo es requerido";

        return errors;
    }

    const onSubmit = async (values: ValuesForm): Promise<void> => {
        const payload = {
            rut: unmaskRUT(values.rut),
            name: values.name
        }
        const resp = await (!isEdit ? createDriver(payload) : updateDriver(driverSelected?.id, payload))
        if (resp == true) {
            onClose()
            onList()
        }
    }

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    width: { xs: '100%', sm: 480 },
                    borderRadius: '12px 0 0 12px',
                    backgroundColor: '#fafafa',
                    display: 'flex',
                    flexDirection: 'column',
                },
            }}
        >
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                px={2}
                py={1.5}
                sx={{
                    backgroundColor: '#f5f7f9',
                    borderBottom: '1px solid #e0e0e0'
                }}
            >
                <Box>
                    <Typography variant="h6" fontWeight={700}>
                        {`${isEdit ? 'Nuevo' : 'Editar'} conductor`}
                    </Typography>
                </Box>

                <IconButton
                    onClick={onClose}
                    sx={{
                        backgroundColor: 'rgba(0,0,0,0.04)',
                        '&:hover': { backgroundColor: 'rgba(0,0,0,0.08)' },
                    }}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </Box>

            <Formik
                initialValues={data}
                enableReinitialize
                validate={validateForm}
                onSubmit={onSubmit}
            >
                {({ values, errors, touched, handleSubmit, handleChange, setFieldValue }) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={2} p={2}>
                                <Grid item xs={12}>
                                    <FormLabel>RUT:</FormLabel>
                                    <TextField
                                        id="rut"
                                        type="text"
                                        name="rut"
                                        fullWidth
                                        size="small"
                                        value={values.rut}
                                        onChange={(e) => {
                                            const { value } = e.target

                                            let newValue = value

                                            let cleanRut = value.replace(/[^0-9kK]/g, '').toUpperCase()

                                            let rutBody = cleanRut.slice(0, -1)
                                            let dv = cleanRut.slice(-1)

                                            rutBody = rutBody.slice(0, 8)
                                            dv = dv.replace(/[^0-9K]/g, '')

                                            let formatted = ''
                                            if (rutBody.length > 0) {
                                                let reversed = rutBody.split('').reverse()
                                                let withDots: string[] = []

                                                for (let i = 0; i < reversed.length; i++) {
                                                    withDots.push(reversed[i])
                                                    if ((i + 1) % 3 === 0 && i + 1 < reversed.length) {
                                                        withDots.push('.')
                                                    }
                                                }

                                                formatted = withDots.reverse().join('')
                                            }

                                            if (dv) {
                                                formatted += `-${dv}`
                                            }

                                            newValue = formatted

                                            setFieldValue('rut', newValue)
                                        }}
                                        error={errors.rut && touched.rut ? true : false}
                                        helperText={errors.rut && touched.rut ? errors.rut : ''}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <FormLabel>{'Nombre(s):'}</FormLabel>
                                    <TextField
                                        id="name"
                                        type="text"
                                        name="name"
                                        fullWidth
                                        size="small"
                                        value={values.name}
                                        onChange={handleChange}
                                        error={errors.name && touched.name ? true : false}
                                        helperText={errors.name && touched.name ? errors.name : ''}
                                    />
                                </Grid>
                                <Divider />
                                <Grid item xs={12} sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                                    <ModalFooter
                                        buttonType="submit"
                                        confirmText={'Guardar'}
                                        onConfirm={handleSubmit}
                                        cancelText={"Cancelar"}
                                        onCancel={onClose}
                                        loadingConfirmText={status === ApiStatus.FETCHING}
                                    />
                                </Grid>
                            </Grid>
                        </form>
                    )
                }}
            </Formik>
        </Drawer>
    )
}